import React from "react";

const About = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h1 className="text-2xl font-extrabold text-gray-900">
        About Minilo AI Blog
      </h1>

      <p className="mt-4 text-gray-700 leading-relaxed">
        Welcome to{" "}
        <span className="font-semibold text-blue-600">Minilo AI Blog</span>,
        your source for Minilo AI-generated articles on the latest trending
        topics. Our advanced Minilo AI scans the web for the most talked-about
        subjects and delivers insightful, well-structured, and SEO-optimized
        content every day.
      </p>

      <h2 className="mt-6 text-2xl font-semibold text-gray-800">
        Why Minilo AI Blog?
      </h2>
      <ul className="mt-3 space-y-2 text-gray-700 list-disc list-inside">
        <li>
          <strong>Daily Trending Topics:</strong> Stay updated with fresh,
          relevant content.
        </li>
        <li>
          <strong>Minilo AI-Powered Content:</strong> Get automatically
          generated articles with accuracy and depth.
        </li>
        <li>
          <strong>SEO-Optimized:</strong> Articles designed to rank higher on
          search engines.
        </li>
        <li>
          <strong>Minilo Article Images:</strong> Each article comes with a
          google search API image.
        </li>
      </ul>

      <h2 className="mt-6 text-2xl font-semibold text-gray-800">
        How It Works
      </h2>
      <p className="mt-3 text-gray-700">
        Our system analyzes the top trending topics daily using Google Trends,
        generates well-structured articles, and pairs them with Minilo
        AI-generated images. Everything is automated to ensure fresh and
        relevant content every day.
      </p>

      <h2 className="mt-6 text-2xl font-semibold text-gray-800">
        Join the Minilo AI Blog Community
      </h2>
      <p className="mt-3 text-gray-700">
        Whether you're a reader looking for insightful content or a creator
        exploring Minilo AI-powered content generation, Minilo AI Blog helps you
        stay ahead of trends.
      </p>
    </div>
  );
};

export default About;
